import { useState, useEffect } from 'react'
import classNames from 'classnames'
import { Box } from '@homebot/shared-ui-swashbuckle'
import { HomeSvg, ForSaleSignSvg, GraphSvg } from '../../../../../svgs'
import styles from './HomeValueEstimateAnimation.module.scss'

export interface StationaryDotProps {
  className?: string
  svgType: 'forSale' | 'home' | 'graph'
}

const StationaryDot = ({ className, svgType }: StationaryDotProps) => {
  const svgProps = { height: 24, width: 24 }

  return (
    <span className={classNames(styles.dot, styles.stationaryDot, className)}>
      {svgType === 'forSale' && <ForSaleSignSvg {...svgProps} />}
      {svgType === 'home' && <HomeSvg {...svgProps} />}
      {svgType === 'graph' && <GraphSvg {...svgProps} />}
    </span>
  )
}

const MovingDot = () => {
  return <div className={classNames(styles.dot, styles.movingDot)} />
}

export const HomeValueEstimateAnimation = () => {
  const [animating, setAnimating] = useState(false)

  useEffect(() => {
    function handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        setAnimating(true)
      } else {
        setAnimating(false)
      }
    }

    setTimeout(() => setAnimating(true), 350)

    window.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      window.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  const NUMBER_OF_MOVING_DOTS = 9
  const movingDots = [...Array(NUMBER_OF_MOVING_DOTS).keys()]
  const movingDotDelayClassName = animating && styles.movingDotDelayed

  return (
    <Box width={'100%'} display='flex' justifyContent='center'>
      <div className={classNames(styles.container, movingDotDelayClassName)}>
        <StationaryDot svgType='forSale' />
        <StationaryDot svgType='home' />
        <StationaryDot svgType='graph' />
        {movingDots.map(_key => {
          return <MovingDot key={_key} />
        })}
      </div>
    </Box>
  )
}
